<template>
  <v-row class="mb-8">
    <v-col cols="12" class="mt-4" v-if="!loading">
      <h3 v-if="juries.length>0" class="font-weight-regular text-uppercase">Jurados:</h3>
    </v-col>

    <v-col 
      cols="12" 
      xl="3" 
      md="3" 
      sm="12" 
      align="center"
      v-for="(jury) in juries"
      :key="jury.id">
    
      <cardPerson
        v-if="!loading" 
        :data="jury"
        :backgroundCard="jury_background_card"
      />

    </v-col>

    <v-col cols="12" class="mt-4" v-if="!loading">
      <h3 v-if="evaluators.length>0" class="font-weight-regular text-uppercase">Evaluadores:</h3>
    </v-col>

    <v-col 
      cols="12" 
      xl="3" 
      md="3" 
      sm="12" 
      align="center"
      v-for="(evaluator) in evaluators" 
      :key="evaluator.id">

      <cardPerson 
        v-if="!loading" 
        :data="evaluator"
        :backgroundCard="evaluator_background_card"
      />

    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL
  import { mapGetters } from 'vuex'
  import cardPerson from '@/components/card/cardPerson'

  export default {
    name: 'juriesAndEvaluators',
    components:{cardPerson},

    data: () => ({
      loading:true,
      juries:[],
      evaluators:[],
      jury_background_card: null,
      evaluator_background_card: null
    }),

    computed: {
      ...mapGetters([
        'edition'
      ])
    },

    methods:{
      setData(){
        this.jury_background_card = APP_URL + this.edition.edition.edition_customization.jury_background_card
        this.evaluator_background_card = APP_URL + this.edition.edition.edition_customization.evaluator_background_card
      },

      async getJuriesEdition(){
        await axios.get('participant/juries/'+this.edition.edition.id).then(response =>{
          this.juries = response.data.data.juries
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      async getEvaluatorsEdition(){
        await axios.get('participant/evaluators/'+this.edition.edition.id).then(response =>{
          this.evaluators = response.data.data.evaluators
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      handleEdition(){
        if(this.edition.edition.waiting_room){
          this.loading = false
          this.$router.push({ name: 'home' })
        }
      }
    },
    created(){
      Promise.all([
        this.handleEdition(),
        this.setData(),
        this.getJuriesEdition(),
        this.getEvaluatorsEdition()
      ]).then(() => {
        this.loading=false
      }).catch((error) => {
        console.log(error)
      });
    }
  }
</script>